<template>
    <div>
        <List
            :fields="fields"
            :items="items"
            track-by="space_type_id"
            @row-clicked="handleRowClicked"
        />
    </div>
</template>

<script>
import List from '@/components/locations/List';
import ModalNavigation from '@/mixins/ModalNavigation';
import LocationsDataMixin from '../LocationsDataMixin';

const fields = [
    {
        name: 'space_type_id',
        title: 'id',
    },
    {
        name: 'space_type_name',
        title: 'name',
    },
];

export default {
    components: { List },

    mixins: [ModalNavigation, LocationsDataMixin],

    props: {
        fields: {
            type: Array,
            default() {
                return fields;
            },
        },
    },

    computed: {
        items() {
            return Object.values(this.spaceTypes);
        },
    },

    methods: {
        handleRowClicked(item) {
            this.$router.push({
                name: 'locations.spacetypes.details',
                params: {
                    id: item.space_type_id,
                },
            });
        },
    },
};
</script>
